import { render, staticRenderFns } from "./ProfessionalRegisterButton.vue?vue&type=template&id=915d8c66&"
import script from "./ProfessionalRegisterButton.vue?vue&type=script&lang=js&"
export * from "./ProfessionalRegisterButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports